import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { AccountService } from './account.service';
import { PaymentParams } from '../../account/account.model';

@Injectable()
export class AlertPaymentService {
  public onActivatePaymentAlert = new BehaviorSubject<boolean>(false);
  public onPaymentParamsFetch = new BehaviorSubject<PaymentParams>(null);

  constructor(private http: HttpClient, public accountService: AccountService) {}

  activatePaymentAlert(isPaymentFailed: boolean) {
    this.onActivatePaymentAlert.next(isPaymentFailed);
  }

  alertUnpaidStatus() {
    this.accountService.getCurrentSubscriptionPaymentStatus().subscribe(paymentStatus => {
      this.onPaymentParamsFetch.next(paymentStatus);
      this.activatePaymentAlert(
        paymentStatus &&
          paymentStatus.status &&
          ['requires_action', 'requires_payment_method', 'canceled', 'requires_confirmation'].includes(
            paymentStatus.status
          )
      );
    });
  }
}
